import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../core/logManager";
import { resetALL } from "../../../../../.globals/redux/actions";

const INIT_STATE = {
  loading: false,
  items: [],
  total: 0,
  error: null,
  entities: []
};

const route = "modules/manage/views/main/components/asset/redux/slice";

const manageSearchAsset = createAsyncThunk(
  "manage/asset/manageSearchAsset",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchAsset.query,
        {
          conditions,
          sort,
          limit,
          offset,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchAsset");
      return rejectWithValue(exc);
    }
  }
);

manageSearchAsset.query = `
    query ($conditions: [AssetSearchInput], $sort: [AssetSortInput], $limit: Int, $offset: Int) {
        data: searchAssets(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
          total
          items {
            id
            label
            unitId
            unit {
              id
              label
            }
            assetTypeId
            assetType {
              entityId
              label
            }
            assetSubtypeId
            assetSubtype {
              id
              name
            }
            vin
            inspectionDeviceType
            externalId
            isActive
            tagIds
            tags {
              id
              label
              color
            }
          }
        }
    }
`;

const manageSearchEntityList = createAsyncThunk(
  "manage/asset/manageSearchEntityLists",
  async ({ limit = 100, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchEntityList.query,
        {
          conditions: [{
            fields: ["entityName"],
            terms: ["AssetType", "InspectionDeviceType"]
          }],
          sort: {
            field: "entityName",
            order: "ASC"
          },
          limit,
          offset,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchEntityLists");
      return rejectWithValue(exc);
    }
  }
);

manageSearchEntityList.query = `
    query ($conditions: [EntityListSearchInput], $sort: [EntityListSortInput], $limit: Int, $offset: Int) {
        data: searchEntityLists(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
          total
          items {
            entityId
            entityName
            parentId
            label
          }
        }
    }
`;


export { manageSearchAsset, manageSearchEntityList }

//Slice
const manageAssetTabRedux = createSlice({
  name: "manage/asset",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchKeyFobs
    builder.addCase(manageSearchAsset.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageSearchAsset.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload.items;
      state.total = action.payload.total;
    });
    builder.addCase(manageSearchAsset.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    //manageSearchEntityList
    builder.addCase(manageSearchEntityList.fulfilled, (state, action) => {
      state.entities = action.payload.items;
    });
    builder.addCase(manageSearchEntityList.rejected, (state, action) => {
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageAssetTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;